import RichText from "../components/RichText";
function RichTextPage(){

    return(
        <RichText/>

    );
}
export default RichTextPage